import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-759eb2a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modern-form-container" };
const _hoisted_2 = { class: "form-card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"header-icon\" data-v-759eb2a4><svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-759eb2a4><path d=\"M3 21h18\" data-v-759eb2a4></path><path d=\"M5 21V7l8-4v18\" data-v-759eb2a4></path><path d=\"M19 21V11l-6-4\" data-v-759eb2a4></path><line x1=\"9\" y1=\"9\" x2=\"9\" y2=\"9.01\" data-v-759eb2a4></line><line x1=\"9\" y1=\"12\" x2=\"9\" y2=\"12.01\" data-v-759eb2a4></line><line x1=\"9\" y1=\"15\" x2=\"9\" y2=\"15.01\" data-v-759eb2a4></line><line x1=\"15\" y1=\"13\" x2=\"15\" y2=\"13.01\" data-v-759eb2a4></line><line x1=\"15\" y1=\"16\" x2=\"15\" y2=\"16.01\" data-v-759eb2a4></line></svg></div>", 1);
const _hoisted_5 = { class: "form-title" };
const _hoisted_6 = { class: "form-subtitle" };
const _hoisted_7 = { class: "card-body" };
const _hoisted_8 = {
    key: 0,
    class: "warning-banner"
};
const _hoisted_9 = /*#__PURE__*/ _createStaticVNode("<div class=\"warning-icon\" data-v-759eb2a4><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-759eb2a4><path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\" data-v-759eb2a4></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\" data-v-759eb2a4></line><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\" data-v-759eb2a4></line></svg></div>", 1);
const _hoisted_10 = { class: "form-grid" };
const _hoisted_11 = { class: "input-group full-width" };
const _hoisted_12 = { class: "input-group" };
const _hoisted_13 = {
    key: 0,
    class: "input-status confirmed"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("polyline", { points: "20,6 9,17 4,12" })
], -1));
const _hoisted_15 = {
    key: 1,
    class: "input-status warning"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "12",
        y1: "9",
        x2: "12",
        y2: "13"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "12",
        y1: "17",
        x2: "12.01",
        y2: "17"
    })
], -1));
const _hoisted_17 = { class: "input-group" };
const _hoisted_18 = { class: "input-group" };
const _hoisted_19 = { class: "input-group" };
const _hoisted_20 = { class: "input-group" };
const _hoisted_21 = { class: "input-group" };
const _hoisted_22 = { class: "input-group" };
const _hoisted_23 = { class: "input-group" };
const _hoisted_24 = { class: "input-group" };
const _hoisted_25 = { class: "input-group" };
const _hoisted_26 = {
    key: 0,
    class: "input-group"
};
const _hoisted_27 = {
    key: 0,
    class: "referral-status"
};
const _hoisted_28 = {
    key: 0,
    class: "status-valid"
};
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("polyline", { points: "20,6 9,17 4,12" })
], -1));
const _hoisted_30 = {
    key: 1,
    class: "status-invalid"
};
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "15",
        y1: "9",
        x2: "9",
        y2: "15"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "9",
        y1: "9",
        x2: "15",
        y2: "15"
    })
], -1));
const _hoisted_32 = {
    key: 0,
    class: "banner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_select = _resolveComponent("hit-select");
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.stepper_company_information')), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.company_form_verify_and_complete_your_company_details')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
                (!_ctx.myObject.checkVatNumberBeforeAddAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.vat_number_not_checked')), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_hit_form, {
                    name: "CompanyInformationForm",
                    value: _ctx.objectFormData,
                    validations: _ctx.validations,
                    "force-cancel-button-hidden": true,
                    "force-save-button-hidden": true
                }, {
                    default: _withCtx(({ formData, validationState }) => [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_hit_select, {
                                    name: "userLanguageSystem",
                                    class: "modern-input required-field",
                                    value: formData.userLanguageSystem,
                                    "label-fields": ['designation'],
                                    options: _ctx.HitLanguageUtils.getSupportedLanguageOptions(),
                                    label: _ctx.t('admin-ui.language_system') + ' *',
                                    "validation-state": validationState.userLanguageSystem,
                                    filterable: false,
                                    clearable: false,
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onChange: _ctx.onChangeUserLanguageSystem
                                }, null, 8, ["value", "options", "label", "validation-state", "placeholder", "onChange"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_hit_input, {
                                    name: "vatNumber",
                                    class: "modern-input required-field",
                                    value: formData.vatNumber || '',
                                    "validation-state": validationState.vatNumber,
                                    label: _ctx.t('admin-ui.label_vat_number') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    disabled: true,
                                    onInput: _ctx.onChangeVatNumber
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                (_ctx.myObject.checkVatNumberBeforeAddAccount)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.company-vat-verified')), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.vat-number-not-verified')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_hit_input, {
                                    name: "designationLegal",
                                    class: "modern-input required-field",
                                    value: formData.designationLegal || '',
                                    "validation-state": validationState.designationLegal,
                                    label: _ctx.t('admin-ui.label_legal_designation') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeDesignationLegal
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_hit_input, {
                                    name: "street",
                                    class: "modern-input required-field",
                                    value: formData.street || '',
                                    "validation-state": validationState.street,
                                    label: _ctx.t('admin-ui.label_street') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeStreet
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_hit_input, {
                                    name: "houseNumber",
                                    class: "modern-input required-field",
                                    value: formData.houseNumber || '',
                                    "validation-state": validationState.houseNumber,
                                    label: _ctx.t('admin-ui.label_house_number') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeHouseNumber
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_hit_input, {
                                    name: "boxNumber",
                                    class: "modern-input",
                                    value: formData.boxNumber || '',
                                    "validation-state": validationState.boxNumber,
                                    label: _ctx.t('admin-ui.box_number'),
                                    placeholder: _ctx.t('admin-ui.optional'),
                                    onInput: _ctx.onChangeBoxNumber
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_hit_input, {
                                    name: "postCode",
                                    class: "modern-input required-field",
                                    value: formData.postCode || '',
                                    "validation-state": validationState.postCode,
                                    label: _ctx.t('admin-ui.label_post_code') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangePostCode
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_hit_input, {
                                    name: "city",
                                    class: "modern-input required-field",
                                    value: formData.city || '',
                                    "validation-state": validationState.city,
                                    label: _ctx.t('admin-ui.city') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeCity
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_hit_input, {
                                    name: "phone",
                                    class: "modern-input required-field",
                                    value: formData.phone || '',
                                    "validation-state": validationState.phone,
                                    label: _ctx.t('admin-ui.label_phone') + ' *',
                                    placeholder: _ctx.t('admin-ui.required'),
                                    type: "tel",
                                    onInput: _ctx.onChangePhone
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_hit_input, {
                                    name: "mobile",
                                    class: "modern-input",
                                    value: formData.mobile || '',
                                    "validation-state": validationState.mobile,
                                    label: _ctx.t('admin-ui.mobile'),
                                    placeholder: _ctx.t('admin-ui.optional'),
                                    type: "tel",
                                    onInput: _ctx.onChangeMobile
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_hit_input, {
                                    name: "activity",
                                    class: "modern-input",
                                    value: formData.activity || '',
                                    "validation-state": validationState.activity,
                                    label: _ctx.t('admin-ui.activity'),
                                    placeholder: _ctx.t('admin-ui.optional'),
                                    type: "text",
                                    onInput: _ctx.onChangeActivity
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"])
                            ]),
                            (_ctx.enableReferralSystem === 'true')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_component_hit_input, {
                                        name: "referralCode",
                                        class: "modern-input",
                                        value: formData.referralCode || '',
                                        "validation-state": validationState.referralCode,
                                        label: _ctx.t('admin-ui.referral_code'),
                                        placeholder: _ctx.t('admin-ui.optional'),
                                        type: "text",
                                        onInput: _ctx.onChangeReferralCode
                                    }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                    (_ctx.objectFormData.referralCode)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            (_ctx.referralCodeValid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                    _hoisted_29,
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.referral-code-is-valid')), 1)
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _hoisted_31,
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.referral-code-is-invalid')), 1)
                                                ]))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["value", "validations"])
            ])
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
